/** Non-destructive AI flow preview and safe Assembly application. */
export const storyFlowSignature=paper=>JSON.stringify({
 blocks:(paper.blocks||[]).map(b=>[b.id,b.sourceId,b.start,b.end,b.text]),
 headings:paper.sectionHeadings||[]
});

export const suggestedFlowBlocks=(paper,orderedIds)=>{
 const blocks=paper.blocks||[];
 const ids=blocks.map(block=>block.id);
 if(!Array.isArray(orderedIds)||orderedIds.length!==ids.length||
   new Set(orderedIds).size!==ids.length||orderedIds.some(id=>!ids.includes(id)))
   throw new Error('AI returned an invalid passage order.');
 const byId=new Map(blocks.map(block=>[block.id,block]));
 return orderedIds.map(id=>byId.get(id));
};

export const flowMoveCount=(paper,orderedIds)=>orderedIds.reduce(
 (total,id,index)=>total+(paper.blocks[index]?.id===id?0:1),0
);

export const applySuggestedFlow=(paper,proposal,{applyHeadings=false,idFactory=()=>crypto.randomUUID()}={})=>{
 const blocks=suggestedFlowBlocks(paper,proposal.orderedIds);
 const reasons=new Map((proposal.decisions||[]).map(item=>[item.id,item.reason]));
 const cleaned=blocks.map(block=>{
  const {editorialFlowReason,...rest}=block;
  return reasons.has(block.id)&&reasons.get(block.id)
   ?{...rest,editorialFlowReason:reasons.get(block.id)}:rest;
 });
 const current=paper.blocks||[];
 // Keep existing human-authored headings attached to the passage they preceded.
 // Headings originally after the last passage stay at the end.
 const headings=(paper.sectionHeadings||[]).map(section=>{
  const at=Number(section.beforeIndex);
  const anchor=at>=0&&at<current.length?current[at]?.id:null;
  return {...section,beforeIndex:anchor?proposal.orderedIds.indexOf(anchor):blocks.length};
 });
 if(applyHeadings){
  const suggested=proposal.headings||[];
  if(suggested.some(h=>!h.title?.trim()||!proposal.orderedIds.includes(h.beforeId)))
   throw new Error('Suggested headings are incomplete.');
  return {...paper,blocks:cleaned,sectionHeadings:suggested.map(h=>({
   id:idFactory(),title:h.title.trim(),editorialReason:h.reason,
   beforeIndex:proposal.orderedIds.indexOf(h.beforeId)
  }))};
 }
 return {...paper,blocks:cleaned,sectionHeadings:headings};
};
